/* ============================================================
   cs-config.js
   Read-only helpers over window.CS_PRODUCTS.

   RULE: no block anywhere in this theme hardcodes a variant ID or a
   price. Ask this file instead. If the answer is undefined, the product
   is missing from snippets/cs-product-config.liquid, so fix it there.
   ============================================================ */
window.CS = (function () {
  var P = window.CS_PRODUCTS || {};
  var S = window.CS_SHOP || { moneyFormat: '${{amount}}' };

  function product(handle) {
    return P[handle] || null;
  }

  /* Variant by title, e.g. variant('shipping-protection', '$20') */
  function variant(handle, variantTitle) {
    var p = product(handle);
    if (!p) return null;
    if (!variantTitle) return p.variants[0] || null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].title === variantTitle) return p.variants[i];
    }
    return null;
  }

  function variantById(id) {
    id = Number(id);
    for (var h in P) {
      if (!Object.prototype.hasOwnProperty.call(P, h)) continue;
      for (var i = 0; i < P[h].variants.length; i++) {
        if (P[h].variants[i].id === id) return P[h].variants[i];
      }
    }
    return null;
  }

  /* Price in CENTS. Shopify works in cents everywhere, so do we. */
  function price(handle, variantTitle) {
    var v = variant(handle, variantTitle);
    return v ? v.price : null;
  }

  function priceFormatted(handle, variantTitle) {
    var v = variant(handle, variantTitle);
    return v ? v.priceFormatted : null;
  }

  /* Format any cent value using the shop's own money format. */
  function money(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) return '';
    var amount = (Number(cents) / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCommas = parts.join('.');
    var noCents = parts[0];

    return S.moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noCents)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noCents.replace(/,/g, ' '));
  }

  /* Cheapest available variant, handy for "from $X" labels. */
  function cheapest(handle) {
    var p = product(handle);
    if (!p) return null;
    var best = null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (!v.available) continue;
      if (!best || v.price < best.price) best = v;
    }
    return best;
  }

  /* Loud in dev, silent for shoppers. */
  function warnIfMissing() {
    var missing = window.CS_PRODUCTS_MISSING || [];
    if (!missing.length) return;
    var isEditor = window.Shopify && window.Shopify.designMode;
    var isPreview = /preview_theme_id|_ab=/.test(window.location.search);
    if (isEditor || isPreview) {
      console.warn('[CS] Handles in cs-product-config.liquid with no matching product:', missing);
    }
  }
  warnIfMissing();

  return {
    product: product,
    variant: variant,
    variantById: variantById,
    price: price,
    priceFormatted: priceFormatted,
    money: money,
    cheapest: cheapest,
    all: P
  };
})();
